/* tslint:disable:max-line-length */
import { colors } from '@mm/utils';
import classNames from 'classnames';
import React from 'react';
import { IconTypeProps } from '../types';

export const CheckedLightIcon = ({
  className,
  color = colors.green,
  onClick,
  size,
}: IconTypeProps) => {
  const styles = {
    width: size,
    height: size,
  };
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classNames(className)}
      onClick={onClick}
      style={styles}
    >
      <path
        d="M11.625 0C5.20467 0 0 5.20467 0 11.625C0 18.0453 5.20467 23.25 11.625 23.25C18.0453 23.25 23.25 18.0453 23.25 11.625C23.25 5.20467 18.0453 0 11.625 0ZM11.625 21.75C6.06262 21.75 1.5 17.2474 1.5 11.625C1.5 6.06267 6.00258 1.5 11.625 1.5C17.1874 1.5 21.75 6.00258 21.75 11.625C21.75 17.1873 17.2474 21.75 11.625 21.75ZM18.2639 8.8612L9.80391 17.2533C9.58336 17.4721 9.2272 17.4707 9.00844 17.2501L4.98291 13.1921C4.76414 12.9715 4.76555 12.6154 4.98609 12.3966L5.38547 12.0005C5.60602 11.7817 5.96217 11.7831 6.18094 12.0037L9.41419 15.263L17.0755 7.66317C17.296 7.44441 17.6522 7.44581 17.871 7.66636L18.2671 8.06573C18.4859 8.28628 18.4845 8.64244 18.2639 8.8612Z"
        fill={color}
      />
    </svg>
  );
};
